export const WEBSITES = {
         MEDTRAIL: 'MEDTRAIL',
         DISPENSARY: 'DISPENSARY',
         MYHEALTHBOOK: 'MYHEALTHBOOK',
         DIAGNOSTICS: 'DIAGNOSTICS',
       };
